import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ConfLobControlService } from '../../Conf-Shared/Services/conf-lob-service/conf-lob-control.service';
import { ActivatedRoute, ChildrenOutletContexts, Router } from '@angular/router';
import * as actions from '../../conf-store/action/index'
import * as ilmcvSteps from "../../Conf-Shared/StaticData/ILMCV/ilmcv-steps.json";
import * as scvSteps from "../../Conf-Shared/StaticData/SCV/scv-steps.json";
import * as hcvSteps from "../../Conf-Shared/StaticData/HCV/hcv-steps.json";
import * as wingerSteps from "../../Conf-Shared/StaticData/WINGER/winger-steps.json";
import * as busSteps from "../../Conf-Shared/StaticData/BUS/bus-steps.json";
import * as magicSteps from "../../Conf-Shared/StaticData/MAGIC/magic-steps.json";
import { slideInAnimation } from '../../../conf-animations';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, lastValueFrom, take } from 'rxjs';
import { getAllState } from '../../../configurator-app/conf-store/reducer';
import { resetAllState } from '../../conf-store/action/index';

@Component({
  selector: 'app-conf-configurator-layout',
  templateUrl: './conf-configurator-layout.component.html',
  styleUrls: ['./conf-configurator-layout.component.scss'],
  animations: [
    slideInAnimation,

  ]
})
export class ConfConfiguratorLayoutComponent implements OnInit {
  postReqSubs: any;
  postSubscribe: any = new Subscription;
  configuratorId: any = null;
  receivedLob: any = null

  lob: any = '';
  utm_source: any;
  utm_medium: any;
  utm_campaign: any;
  gclid: any;
  includeQueryParam: boolean = false
  constructor(private activatedRoute: ActivatedRoute, private _dataLobService: ConfLobControlService, private router: Router, private store: Store, private contexts: ChildrenOutletContexts, private cookie_service: CookieService) { }

  async ngOnInit(): Promise<void> {
    let confUrlSplit = this.router.url.split("/");


    // let confId = this.cookie_service.get("configuration_id")
    let state: any;

    if (confUrlSplit[1] == "osp-configurator") {
      let confId = decodeURIComponent(confUrlSplit[2])

      if (confId.includes('?')) {
        this.includeQueryParam = true
        confId = confId.split('?')[0];
        this.campaign()
        //paramValue = httpParams.get(paramName);
      }else{
        this.includeQueryParam = false
      }
      
      let payload = { "configuration_id": confId }
      this._dataLobService.getLobFilterData('fetch_configuration_id_details', payload).subscribe((result) => {

        if (result['RESPONSE']['STATUS_CODE'] == 200 && result['RESPONSE']['DATA'].length > 0) {
          this.cookie_service.set("configuration_id", confId)

          let selectedLob = result['RESPONSE']['DATA'][0]['lob'];
          let stepJson = result['RESPONSE']['DATA'][0]['last_visited_step_json'];
          let parsedJson = JSON.parse(stepJson);

          state = parsedJson

          let stateStepbar = parsedJson['stepState']
          let stateLobData = parsedJson['lobDataState']

          if(parsedJson['stepState'] == undefined){
            stateStepbar = state
          }

          let index = stateStepbar.currentStep
          let pathIndex = stateStepbar.stepArr[index]['path'];

          //Stepbar Reinit
          this.store.dispatch(actions.stepbarStateReinit(stateStepbar))

          if(parsedJson['stepState'] != undefined){
            this.store.dispatch(actions.lobDataStateReinit(stateLobData))
          }
          

          //For initializing selected lob
          this.store.dispatch(actions.saveSelectedLob(selectedLob))

          if(!this.includeQueryParam){
            this.router.navigate(['/configurator/' + pathIndex]);
          }else{
            this.router.navigate(['/configurator/' + pathIndex], { queryParams: { utm_source: this.utm_source, utm_medium: this.utm_medium, utm_campaign: this.utm_campaign } });
          }
          
        }else{
          this.router.navigate(['/configurator/configurator-not-found'])
        }
      }, (error) => (
        this.router.navigate(['/configurator/configurator-not-found'])
      ))
    } else {
      //this.store.dispatch(resetAllState())
      state = await lastValueFrom(this.store.pipe(select(getAllState), take(1)));
    }

    var expire = new Date();
    var time = Date.now() + ((3600 * 1000) * 6); // current time + 6 hours ///
    expire.setTime(time);

    let lobRoute = this.router.url.split("/");
    if (state?.stepBarState?.stepArr?.length === 0) {

      this.lob = lobRoute[2]

      //for initializing stepbar
      if (lobRoute[2] === 'ilmcv')
        this.store.dispatch(actions.stepBarInit(ilmcvSteps.default.stepData))
      else if (lobRoute[2] === 'hcv')
        this.store.dispatch(actions.stepBarInit(hcvSteps.default.stepData))
      else if (lobRoute[2] === 'bus')
        this.store.dispatch(actions.stepBarInit(busSteps.default.stepData))
      else if (lobRoute[2] === 'scv')
        this.store.dispatch(actions.stepBarInit(scvSteps.default.stepData))
      else if (lobRoute[2] === 'winger')
        this.store.dispatch(actions.stepBarInit(wingerSteps.default.stepData))
      else if (lobRoute[2] === 'magic')
        this.store.dispatch(actions.stepBarInit(magicSteps.default.stepData))

      //For initializing selected lob
      this.store.dispatch(actions.saveSelectedLob(lobRoute[2]))
    }
  }

  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign = await params['utm_campaign'] || await params['utm_campaignname'];
      this.gclid = await params['gclid'];
    })
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
  onActivate(event: Event) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
